import type {AxiosError, AxiosRequestConfig, AxiosResponse} from 'axios';
import axios from 'axios';
import {useMessage} from "@/utils/useMessage";
import {delAuthCache} from "@/utils/utils";
import {TOKEN_KEY, USER_INFO_KEY} from "@/enums/cacheEnum";
import {getHeaders} from "@/utils/common/compUtils";
import router from "@/router";

const { createMessage } = useMessage();
// 创建axios实例
const baseUrl = process.env.VITE_GLOB_DOMAIN_URL + process.env.VITE_GLOB_API_URL // 设置API的基础URL
const http = axios.create({
    baseURL: baseUrl
});
// export const download = axios.create({
//     baseURL: baseUrl,
//     timeout: 60000,
//     headers: getHeaders(),
//     responseType: 'blob'
//
// })


// 请求拦截器
http.interceptors.request.use(
    (config: AxiosRequestConfig):any => {
        // 可在请求发送前对config进行修改，如添加请求头等
        // const headers = config.headers || {};
        // headers[ConfigEnum.TOKEN] = getAuthCache(TOKEN_KEY);
        config.headers = getHeaders();
        config.timeout = 60000
        return config;
    },
    (error: AxiosError) => {
        // 处理请求错误
        return Promise.reject(error);
    }
);

// 响应拦截器
http.interceptors.response.use(
    (response: AxiosResponse) => {
        // console.log(response)
        // 对响应数据进行处理
        if(response.status === 200 && response.config.responseType === 'blob'){
            //根据响应头获取文件名称
            return response.data
        }else if(response.data.code == 0 || response.data.code == 200){
            //此处判断是否下载请求
            //正常情况下不处理数据
            return response.data.result;
        }else if(response.status === 401){
            //登录失效
            //清除本地数据
            delAuthCache(TOKEN_KEY)
            delAuthCache(USER_INFO_KEY)
            //跳转登录页面
            const routeUrl = router.resolve({ name: 'login' });
            window.open(routeUrl.href,'_self');
        }else{
            //接口错误，处理message
            createMessage.error(response.data.message);
            return response.data.success
        }
    },
    (error: AxiosError) => {
        console.log(error)

        if(error.status === 401){
            createMessage.error(error.message + " | " + error.response.data.message);
            //登录失效
            //清除本地数据
            delAuthCache(TOKEN_KEY)
            delAuthCache(USER_INFO_KEY)
            //跳转登录页面
            // const routeUrl = router.resolve({ name: 'login' });
            // window.open(routeUrl.href,'_self');
        }else{
            // 处理响应错误
            createMessage.error(error.message + " | " + error.response.data.message);
            return Promise.reject(error);
        }

    }
);

export default http
